import React from 'react'
import PropTypes from 'prop-types'
import './index.css'

const FormFirst = ({onLogin, onCreate}) => {
  return (
    <div className='lf'>
      <h2 className='lf-h2'>Uživatelský účet Dadopa</h2>
      <p className='c-1'>Máte již svůj uživatelský účet? </p>
      <button className='lf-b mb-2' onClick={onLogin}>Přihlaste se</button>
      <p className='c-1'>Uživatelský účet ještě nemáte? Zdarma se zaregistrujte.</p>
      <button className='lf-b' onClick={onCreate}>Registrovat se</button>
    </div>
  )
}

FormFirst.propTypes = {
  onCreate: PropTypes.func.isRequired,
  onLogin: PropTypes.func.isRequired
}

export default FormFirst



// WEBPACK FOOTER //
// ./src/components/UserForms/FormFirst.js